const organicFarming = {
  modalContent: Drupal.t(
    `Products in this segment are generally suitable for the application in organic farming. It must be considered though, that “organic farming” describes a range of different farming methods linked to specific regulations and standards. References to these regulations and standards are made on the dedicated product pages or on the product label.`,
  ),
  modalHeader: Drupal.t(
    'Organic Farming by <span class="branding">COMPO EXPERT</span>',
  ),
};

export default organicFarming;
